const GET_DETAIL_RTW_IMAGE_BY_ID = 'GET_DETAIL_RTW_IMAGE_BY_ID'
const GET_DETAIL_RTW_IMAGE_BY_ID_SUCCESS = 'GET_DETAIL_RTW_IMAGE_BY_ID_SUCCESS'

const PUT_RTW_IMAGE = 'PUT_RTW_IMAGE'
const PUT_RTW_IMAGE_SUCCESS = 'PUT_RTW_IMAGE_SUCCESS'

const POST_RTW_IMAGE = 'POST_RTW_IMAGE'
const POST_RTW_IMAGE_SUCCESS = 'POST_RTW_IMAGE_SUCCESS'

const GET_RTW_IMAGE_PAGES = 'GET_RTW_IMAGE_PAGES'
const GET_RTW_IMAGE_PAGES_SUCCESS = 'GET_RTW_IMAGE_PAGES_SUCCESS'


const RtwImageType = {
  GET_DETAIL_RTW_IMAGE_BY_ID,
  GET_DETAIL_RTW_IMAGE_BY_ID_SUCCESS,

  PUT_RTW_IMAGE,
  PUT_RTW_IMAGE_SUCCESS,

  POST_RTW_IMAGE,
  POST_RTW_IMAGE_SUCCESS,

  GET_RTW_IMAGE_PAGES,
  GET_RTW_IMAGE_PAGES_SUCCESS

}

export default RtwImageType
